/**
 * KONULARIM — F-TPC-01b (04.10.2026, müşteri revizesi)
 *
 * Öğrenci kendi konu listesini TİKLİ ve SALT OKUNUR görüyor; işaretlemeyi
 * eğitim koçu yapıyor. Bu dosya ekranın saf kısmı: durum adları, neyin
 * "tamamlandı" sayıldığı ve ders bazında gruplama. React yok.
 */

/** Sunucudaki `TopicStage` — sıra ve değerler AYNI. */
export type KonuDurumu =
  | "NOT_STARTED"
  | "PLANNED"
  | "IN_PROGRESS"
  | "FIRST_PASS_DONE"
  | "PRACTICING"
  | "NEEDS_REINFORCEMENT"
  | "NEEDS_REVIEW"
  | "VERIFIED_BY_EXAM"
  | "MASTERED";

export const DURUM_ADI: Record<KonuDurumu, string> = {
  NOT_STARTED: "Başlanmadı",
  PLANNED: "Planlandı",
  IN_PROGRESS: "Çalışılıyor",
  FIRST_PASS_DONE: "İlk çalışma bitti",
  PRACTICING: "Soru çözülüyor",
  NEEDS_REINFORCEMENT: "Pekiştirme gerekiyor",
  NEEDS_REVIEW: "Tekrar gerekiyor",
  VERIFIED_BY_EXAM: "Denemede doğrulandı",
  MASTERED: "Tamamlandı",
};

/**
 * Tik alan durumlar — F-TPC-04 ile AYNI tanım: yalnızca "denemede
 * doğrulandı" ve "tamamlandı". "İlk çalışma bitti"yi de saysaydık liste
 * gerçekte olduğundan dolu görünürdü; koç ile öğrencinin gördüğü yüzde
 * ayrışırdı.
 */
export function tamamlandiMi(durum: KonuDurumu): boolean {
  return durum === "MASTERED" || durum === "VERIFIED_BY_EXAM";
}

/** Koçun dikkat istediğini işaretlediği durumlar — listede ayrı tonla. */
export function tekrarGerekiyorMu(durum: KonuDurumu): boolean {
  return durum === "NEEDS_REVIEW" || durum === "NEEDS_REINFORCEMENT";
}

export interface KonuSatiri {
  topicId: string;
  ad: string;
  ders: string;
  lessonId: string;
  arsivli: boolean;
  stage: KonuDurumu;
}

export interface DersGrubu {
  lessonId: string;
  ders: string;
  konular: KonuSatiri[];
  tamamlanan: number;
  toplam: number;
}

/**
 * Ders bazında gruplar; sunucunun sırasını korur.
 *
 * ARŞİVLİ KONU: üzerinde hiç çalışılmamışsa gösterilmiyor (müfredattan
 * çıkarılmış bir konu öğrenciye "eksik" gibi görünmesin). Çalışılmışsa
 * kalıyor — öğrencinin emeği silinmiş gibi görünmesin. Toplama ikisi de
 * GİRMİYOR: yüzde güncel müfredata göre.
 */
export function derslereGore(satirlar: readonly KonuSatiri[]): DersGrubu[] {
  const gruplar = new Map<string, DersGrubu>();
  for (const s of satirlar) {
    if (s.arsivli && s.stage === "NOT_STARTED") continue;
    let g = gruplar.get(s.lessonId);
    if (!g) {
      g = { lessonId: s.lessonId, ders: s.ders, konular: [], tamamlanan: 0, toplam: 0 };
      gruplar.set(s.lessonId, g);
    }
    g.konular.push(s);
    if (!s.arsivli) {
      g.toplam += 1;
      if (tamamlandiMi(s.stage)) g.tamamlanan += 1;
    }
  }
  return [...gruplar.values()];
}
